// extracted by mini-css-extract-plugin
export default {"main":"Steps_main__zf-0I","step":"Steps_step__rdXs1","current":"Steps_current__NzuKn","line":"Steps_line__RjAYU"};